/**
 * hotspotDisplayName — geteilter Namens-Fallback-Helper
 * (F-SW7-11, Owner: SWEEP7-E4-FE-2, Winston §2.2)
 *
 * Gleiches Muster wie `displayName`/`isErrorLikeName`/`shortenAddress` in
 * features/reports/HotspotRewardTable.tsx:26-40 (dort NICHT verändert, da
 * reports-Dateien außerhalb des Boundary-Scopes dieser Story liegen) —
 * hier als eigenständiger, gemeinsam nutzbarer Helper bereitgestellt, damit
 * e4-fe-1 (Dashboard-Widget) denselben Fallback nutzt statt eine zweite,
 * divergente Implementierung zu bauen.
 */

/**
 * Erkennt Namen, die als Anzeigename ungeeignet sind: leer/nur Whitespace
 * oder durchgereichte Backend-/Blockchain-Lookup-Fehlermeldungen
 * (z.B. "Error: No blockchain asset found").
 */
export function isErrorLikeName(name: string | null | undefined): boolean {
  if (!name) return true
  return !name.trim() || /error/i.test(name)
}

/** Kürzt eine Blockchain-Adresse auf ein lesbares Format (erste 6 + letzte 4 Zeichen). */
export function shortenAddress(address: string | null | undefined): string {
  if (!address) return ''
  if (address.length <= 12) return address
  return `${address.slice(0, 6)}…${address.slice(-4)}`
}

/**
 * Wandelt einen rohen Helium-Onboarding-Namen ("bumpy-parchment-gazelle") in
 * eine lesbare Form ("Bumpy Parchment Gazelle") um. Namen ohne Bindestrich
 * bleiben unverändert (z.B. bereits von Nutzern vergebene Namen).
 */
function formatRawName(name: string): string {
  if (!name.includes('-')) return name
  return name
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/**
 * Liefert einen Anzeigenamen für einen Hotspot:
 * 1. echter Name, falls vorhanden und nicht fehlerhaft (Bindestriche werden
 *    dabei in ein lesbares Format umgewandelt, siehe `formatRawName`)
 * 2. gekürzte Adresse, falls vorhanden
 * 3. übersetztes Fallback-Label (z.B. "Unbekannter Hotspot")
 */
export function hotspotDisplayName(
  name: string | null | undefined,
  address: string | null | undefined,
  fallbackLabel: string,
): string {
  if (!isErrorLikeName(name)) return formatRawName(name as string)
  if (address) return shortenAddress(address)
  return fallbackLabel
}
